const PLAN_NAME_KEYS: Record<string, string> = {
  free: 'landing.pricing.plans.free.name',
  level_bundle: 'landing.pricing.plans.level_bundle.name',
  full_access: 'landing.pricing.plans.full_access.name',
};

const humanizePlanId = (planId: string): string => {
  const words = planId
    .trim()
    .split('_')
    .filter(Boolean)
    .map((word) => word.toLowerCase());

  if (words.length === 0) {
    return '';
  }

  const [first, ...rest] = words;
  return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
};

export const getPlanLabel = (
  planId: string | null | undefined,
  t: (key: string) => string,
): string => {
  const normalized = typeof planId === 'string' ? planId.trim().toLowerCase() : '';

  if (!normalized) {
    return String(t(PLAN_NAME_KEYS.free));
  }

  const translationKey = PLAN_NAME_KEYS[normalized];
  if (translationKey) {
    const label = String(t(translationKey));
    if (label && label !== translationKey) {
      return label;
    }
  }

  return humanizePlanId(planId as string) || String(t(PLAN_NAME_KEYS.free));
};
